import React from 'react'

import { getMarkedCookieValue } from '../../utils'
import OwnKeysOnly from './OwnKeysOnly'
import CustomModelOnly from './CustomModelOnly'
import NotIntegrated from './NotIntegrated'

class TryErrorForProduction extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            url: global.INTENTO_CONSOLE_URL || process.env.INTENTO_CONSOLE_URL,
            production: getMarkedCookieValue('IPK'),
        }
    }

    render() {
        const { url, production } = this.state
        if (!production) {
            return null
        }
        const { error, provider } = this.props
        const href =
            provider.id.indexOf('text.translate') !== -1
                ? `${url}/translate/web-tools`
                : `${url}/dashboard`

        if (!provider.integrated) {
            // alibaba
            // youdao
            return <NotIntegrated provider={provider} href={href} />
        }

        if (!provider.billable && !provider.custom_model) {
            // tencent
            // SAP HANA
            if (provider.own_auth) {
                return <OwnKeysOnly provider={provider} href={href} />
            }

            return <NotIntegrated provider={provider} href={href} />
        }

        if (!provider.billable && provider.custom_model) {
            // sdl
            return <CustomModelOnly provider={provider} href={href} />
        }

        // below: some error for an integrated, billable provider

        if (!provider.stock_model && provider.custom_model) {
            // google auto_ml
            return <CustomModelOnly provider={provider} href={href} />
        }

        if (provider.own_auth) {
            return <OwnKeysOnly provider={provider} href={href} />
        }

        return (
            <div className="try-intento__input-control try-intento__error">
                ({error.code}) {error.message}
            </div>
        )
    }
}

export default TryErrorForProduction



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/TryError/TryErrorForProduction.jsx